import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { CustomerAddLocationKeys, DEFAULT_CUSTOMER_ADD_ITEM, initialState } from './constants'
import { CustomerAddLocation, CustomerAddPayload } from './types'
import { getCheckedAddress } from './utils'

export const customerAddSlice = createSlice({
  name: 'customerAdd',
  initialState,
  reducers: {
    clearCustomerAddKeyInfo: (
      state,
      {
        payload: { key }
      }: PayloadAction<{
        key: CustomerAddLocationKeys
      }>
    ) => {
      state[key] = DEFAULT_CUSTOMER_ADD_ITEM
    },
    setCustomerAddSelectedAddress: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['selectedAddress']>
    ) => {
      state[key].selectedAddress = value

      if (value) {
        state[key].customerInfo.legalAddress = value.value
      }
    },
    setCustomerAddErrorAddress: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['errorAddress']>
    ) => {
      state[key].errorAddress = value
    },
    setCustomerAddErrorsCustomerDadataDisableAddForm: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['errorsCustomerDadataDisableAddForm']>
    ) => {
      state[key].errorsCustomerDadataDisableAddForm = value
    },
    setCustomerAddErrorsAddressDadataDisableAddForm: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['errorsAddressDadataDisableAddForm']>
    ) => {
      state[key].errorsAddressDadataDisableAddForm = value
    },
    setCustomerAddErrorCompany: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['errorCompany']>
    ) => {
      state[key].errorCompany = value
    },
    setCustomerAddSearchAddressValue: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['searchAddressValue']>
    ) => {
      state[key].searchAddressValue = value
    },
    setCustomerAddSelectedOptions: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['selectedOptions']>
    ) => {
      state[key].selectedOptions = value
    },
    setCustomerAddIsDadataCustomerDisable: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['isDadataCustomerDisable']>
    ) => {
      state[key].isDadataCustomerDisable = value
    },
    setCustomerAddIsDadataAddressDisable: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['isDadataAddressDisable']>
    ) => {
      state[key].isDadataAddressDisable = value
    },
    setCustomerAddCustomerInfoInitial: (state, { payload: { key } }: CustomerAddPayload<null>) => {
      state[key].customerInfo = initialState[key].customerInfo
    },
    setCustomerAddCustomerInfoName: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['customerInfo']['name']>
    ) => {
      state[key].customerInfo.name = value
    },
    setCustomerAddCustomerInfoInn: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['customerInfo']['inn']>
    ) => {
      state[key].customerInfo.inn = value
    },
    setCustomerAddCustomerInfoKpp: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['customerInfo']['kpp']>
    ) => {
      state[key].customerInfo.kpp = value
    },
    setCustomerAddCustomerInfoLegalAddress: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['customerInfo']['legalAddress']>
    ) => {
      state[key].customerInfo.legalAddress = value
    },
    setCustomerAddCustomerInfoAddressPartial: (
      state,
      { payload: { value, key } }: CustomerAddPayload<CustomerAddLocation['customerInfo']['address']>
    ) => {
      state[key].customerInfo.address = getCheckedAddress({
        currentState: state[key].customerInfo.address,
        newState: value
      })
    }
  }
})

export const customerAddReducer = customerAddSlice.reducer

export const customerAddActions = customerAddSlice.actions
